import { render, staticRenderFns } from "./ProductClient.vue?vue&type=template&id=7e579bcc&scoped=true"
import script from "./ProductClient.vue?vue&type=script&lang=js"
export * from "./ProductClient.vue?vue&type=script&lang=js"
import style0 from "./ProductClient.vue?vue&type=style&index=0&id=7e579bcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e579bcc",
  null
  
)

export default component.exports